(function ($) {
  threeStepPromoLpFormatterV1 = {
    formatter: $('.three-step-promo-lp-formatter-v1')
  };

  Drupal.behaviors.threeStepPromoLpFormatterV1 = {
    get: function (key) {
      return threeStepPromoLpFormatterV1[key];
    },

    set: function (key, val) {
      threeStepPromoLpFormatterV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);
        var offerCode = formatter.find('form [name="GROUP_NAME"]').first().val();

        if (offerCode) {
          var isCheckout = $.inArray('is_checkout', Drupal.cl.getQSParams()) > -1 ? 1 : 0;

          if (isCheckout && offerCode == $.cookie('sample_offers_seen')) {
            document.location = '/checkout/checkout.tmpl?';
          } else {
            $.cookie('sample_offers_seen', offerCode, { path: '/' });
          }
        }

        // Assign data-item to child template
        var bottom = thisFormatter.find('.bottom');
        var stepItem = bottom.find('.items .step-item');

        stepItem.each(function (i) {
          var item = $(this);

          item.attr('data-item', 'item-' + i);
          var firstItem = thisFormatter.find('.bottom .items .step-item[data-item="item-0"]');

          // Apply "active" state to first item and show it on page load
          firstItem.addClass('first').removeClass('hidden').addClass('active');

          // Apply step heading color to step text
          var headingColor = thisFormatter.find('.bottom .items .step-item.active').find('.top .heading span').css('color');
          var stepTextColor = thisFormatter.find('.bottom .items .step-item.active').find('.bottom .step-text span.step-copy').css({ 'color': headingColor });
          // Set Skin Type steps' copy
          var step = item.find('.bottom .step');

          step.each(function (i) {
            var thisStep = $(this);
            var num = i + 1;

            thisStep.find('p').text(thisFormatter.find('.step' + num + '-number').text());
            thisStep.find('p').append('<br><span class="step-copy">' + thisFormatter.find('.step' + num + '-copy').text() + '</span>');
          });

          // Get CTA details
          var ctaButton = thisFormatter.find('.cta-button').text();
          var ctaButtonImg = thisFormatter.find('.cta-button-img').text();

          // Set CTA
          bottom.find('.items .step-item[data-item="item-' + i + '"] .bottom').append('<div class="cta-button-wrapper"></div>');
          var ctaButtonWrapper = item.find('.cta-button-wrapper');

          // CTA image is optional, check if there is one
          if (ctaButtonImg.length) {
            ctaButtonWrapper.append('<img src="' + ctaButtonImg + '" class="cta-button-image" alt="" /><div class="clear"></div>');
          }
          ctaButtonWrapper.append('<a href="#" title="' + ctaButton + '" class="btn-primary btn-large add-to-bag btn-add-to-bag pc">' + ctaButton + '</a>');
        });

        Drupal.behaviors.threeStepPromoLpItemV1.bindAddToBag();

        // Skin Type tiles
        var skinType = thisFormatter.find('.skin-type');

        skinType.each(function (i) {
          var self = $(this);
          var tiles = self.find('img');
          var offTiles = self.find('img.off');
          var activeTiles = self.find('img.active');

          tiles.attr('data-item', 'item-' + i);

          // Apply "active" state to first tile on page load
          var firstTile = self.find('.skin-type-image[data-item="item-0"]');

          firstTile.closest('.skin-type').addClass('first');
          thisFormatter.find('.skin-type.first').find(offTiles).addClass('hidden');
          thisFormatter.find('.skin-type.first').find(activeTiles).removeClass('hidden');

          // Tiles content show/hide on click
          tiles.each(function () {
            var tile = $(this);

            tile.on('click', function() {
              var thisTile = $(this);
              var defaultDataItem = thisTile.attr('data-item');

              // Remove all extra "active" tile
              thisTile.closest('.skin-type').siblings().each(function () {
                var skinType = $(this);

                skinType.find('img.off').filter(function () {
                  var self = $(this);

                  return self.attr('data-item') != defaultDataItem;
                }).removeClass('hidden').next('img.active').addClass('hidden');
              });

              // Add "active" state tile on click
              thisTile.addClass('hidden').next('img.active').removeClass('hidden');

              // Show "Skin Type" content per tile on click
              stepItem.addClass('hidden').removeClass('active');
              stepItem.each(function () {
                var thisStep = $(this);

                thisStep.filter(function () {
                  var self = $(this);

                  return self.attr('data-item') == defaultDataItem;
                })
                  .removeClass('hidden')
                  .addClass('active');
              });

              // Assign heading color to step text
              var headingColor = thisFormatter.find('.bottom .items .step-item.active').find('.top .heading span').css('color');
              var stepTextColor = thisFormatter.find('.bottom .items .step-item.active').find('.bottom .step-text span.step-copy').css({ 'color': headingColor });
            });
          });
        });
      });
    }
  };
})(jQuery);
